import {
    guideClickOnElement,
    guideWaitForElement,
    guideClickOnElementInTopActivity,
    guideFillInput,
    guideWaitForElementLong,
    guideWaitForValue,
    guideDoubleClickOnElement
} from "@/components/dashboard/guides/guidNavigation";

import {isBelowBreakpoint} from "@/utils/Dom";
import EventBus from "@/utils/EventBus";

export function AIInpaintTutorialGuide(initialMenu) {
    let menu = initialMenu;

    return [
        {
            target: '#dark-navbar',
            header: {
                title: 'Hello There',
            },
            content: "I’ll guide you through usage of AI Retouch. Let’s get started!",
            imageSrc: "https://silkplm.com/wp-content/uploads/2024/11/Product-Tour-welcome-screen.png",
            beforeNext: async() => {
                if(isBelowBreakpoint("md")) {
                    EventBus.$emit('openMainMenu');
                    menu = "mobile-";
                } else {
                    menu = "";
                }
            }
        },
        {
            target: () => `#${menu}m-plm`,
            header: {
                title: 'First Step',
            },
            content: "First, open this panel.",
            beforeNext: async () => {
                menu = isBelowBreakpoint("md") ? "mobile-" : "";
                if(isBelowBreakpoint("md")) {
                    EventBus.$emit('openMainMenu');
                    await guideClickOnElement(`#${menu}m-plm`);
                } else {
                    await guideClickOnElement('#m-plm');
                }
                await sleep(500);
            }
        },
        {
            target: () => `#${menu}plm-form-ProductInSeason`,
            header: {
                title: 'Second Step',
            },
            content: "Now, click on the Project section.",
            beforeNext: async () => {
                if (isBelowBreakpoint("md")) {
                    menu="mobile-"
                    await guideClickOnElement(`[id='${menu}plm-form-ProductInSeason'] a`)
                } else {
                    menu=""
                    await guideClickOnElement("[id='plm-form-ProductInSeason'] a")
                }
                await guideWaitForElement('.activity-top [data-test-path="base-grid"] [data-row="0"] [data-col="1"]');
                await sleep(500);
            }
        },
        {
            target: () => '.activity-top [data-test-path="base-grid"] [data-row="0"] [data-col="1"]',
            header: {
                title: 'Third Step',
            },
            content: "Click on first element.",
            beforeNext: async () => {
                await guideClickOnElement('.activity-top [data-test-path="base-grid"] [data-row="0"] [data-col="1"]')
                await sleep(500);
            }
        },
        {
            target: () => '.activity-top [data-test-path="grid-header-details-Products in Season"]',
            header: {
                title: 'Fourth Step',
            },
            content: "Proceed to targeted element details tab.",
            beforeNext: async () => {
                await guideClickOnElement('.activity-top [data-test-path="grid-header-details-Products in Season"]')
                await guideWaitForElement(".activity-top [data-test-path='header-gallery-button']")
                await sleep(500);
            }
        },
        {
            target: () => ".activity-top [data-test-path='header-gallery-button']",
            header: {
                title: 'Fifth Step',
            },
            content: "Click the Gallery button.",
            beforeNext: async () => {
                await guideClickOnElement(".activity-top [data-test-path='header-gallery-button']")
                await guideWaitForElement(".activity-top img[data-test-path='image0']")
                await sleep(500);
            }
        },
        {
            target: () => ".activity-top [data-test-path='image0']",
            header: {
                title: 'Sixth Step',
            },
            content: "Click on the picture",
            beforeNext: async () => {
                await guideClickOnElement(".activity-top [data-test-path='image0']")
                await sleep(500);
            }
        },
        {
            target: () => ".activity-top [data-test-path='details-button']",
            header: {
                title: 'Seventh Step',
            },
            content: "Click on the 'Details' button",
            beforeNext: async () => {
                await guideClickOnElement(".activity-top [data-test-path='details-button']")
                await guideWaitForElement(".activity-top [data-test-path='edit-button']")
                await sleep(500);
            }
        },
        {
            target: () => ".activity-top [data-test-path='edit-button']",
            header: {
                title: 'Eight Step',
            },
            content: "Click on the Edit button",
            beforeNext: async () => {
                await guideClickOnElement(".activity-top [data-test-path='edit-button']")
                await guideWaitForElement(".activity-top .check-primary")
                await sleep(500);
            }
        },
        {
            target: () => ".activity-top .check-primary",
            header: {
                title: 'Ninth Step',
            },
            content: "Proceed to AI Retouch here.",
            beforeNext: async () => {
                await guideClickOnElement(".activity-top .check-primary")
                await guideWaitForElement(".activity-top canvas")
                await sleep(500);
            }
        },
        {
            target: () => ".activity-top img",
            content: "This is a AI Retouch component. Here you can change the image to your liking. On this canvas you can draw whatever you desire.",
        },
        {
            target: () => ".activity-top [data-test-path='paint-size']",
            content: "Here you can change the size of the paintbrush from small, medium to large.",
        },
        {
            target: () => ".activity-top [data-test-path='zoom']",
            content: "You can zoom in, zoom out or reset the size of image.",
        },
        {
            target: () => ".activity-top [data-test-path='show-tooltip']",
            content: "Here is a tooltip with additional information if you do not know what to do.",
        },
        {
            target: () => ".activity-top [data-test-path='write-prompt']",
            content: "Now, click here for prompt.",
            beforeNext: async () => {
                await guideClickOnElement(".activity-top [data-test-path='write-prompt']")
                await guideWaitForElement(".activity-top [data-test-path='prompt']")
                await sleep(500);
            }
        },
        {
            target: () => ".activity-top [data-test-path='prompt']",
            content: "Here you write a prompt to replace the painted part with something you want.",
        },
        {
            target: () => ".activity-top [data-test-path='details-button']",
            content: "In the end, you click here to generate new image.",
            beforeNext: async () => {
                await guideClickOnElement(".activity-top [data-test-path='close-button']")
                await guideWaitForElement(".activity-top .PinturaStage")
                await sleep(500);
            }
        },
        {
            target: () => ".activity-top .PinturaStage",
            content: "That is all for now. Feel free to experiment with it.",
        },
    ];
}
